import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import WhatsAppBanner from "./components/app/WhatsAppBanner";
import LogisticPage from "./pages/logistic/LogisticPage";
import Nav from "./components/app/Nav";
import Presentation from "./components/app/Presentation";
import VideoContainer from "./components/app/VideoContainer";
import TestimonySection from "./components/app/TestimonySection";
import Footer from "./components/app/Footer";
import TeamSection from "./components/app/TeamSection";
import OpinionSection from "./components/app/OpinionSection";
import ServicesSection from "./components/app/ServicesSection";
import AboutChatbotSection from "./components/app/AboutChatbotSection";
import OurServiceSection from "./components/app/OurServicesSection";
import OurAlliesSection from "./components/app/OurAlliesSection";
import PromoSection from "./components/app/PromoSection";
import ComparativeSection from "./components/app/ComparativeSection";
import RatesSection from "./components/app/RatesSection";
import ContactUsSection from "./components/app/ContactUsSection";
import XSection from "./components/app/XSection";
import FeatureSection from "./components/app/FeatureSection";
import PlansSection from "./components/app/PlansSection";
import FunctionsSection from "./components/app/FunctionsSection";
import CalculatorSection from "./components/app/CalculatorSection";
import BlogSection from "./components/blog/BlogSection";
import ClientSection from "./components/app/ClientSection";

const App: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const baseKey = "3CP5bP5R37259vcSjD9V";
    let chatbotKey = baseKey;

    if (location.pathname === "/es-es") {
      chatbotKey ="3CP5bP5R37259vcSjD9V";
    } else if (location.pathname === "/es-us") {
      chatbotKey = "z6cif8sEIKm7166TwNwX";
    }

    const script = document.createElement("script");
    script.src = "https://api.tuagentevirtual.ai/chatbot/chatBox.js";
    script.async = true;
    script.setAttribute("key", chatbotKey); //key para el chatbot
    document.body.appendChild(script);

    const id = sessionStorage.getItem("scrollTo");
    if (id) {
      sessionStorage.removeItem("scrollTo");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    }

    return () => {
      document.body.removeChild(script);
    };
  }, [location.pathname]);

  return (
    <>
      <WhatsAppBanner />
      <Nav />

      <div id="nosotros">
        <Presentation />
      </div>
      <VideoContainer />
      <OurServiceSection />
      <FeatureSection />
      <CalculatorSection />
      <AboutChatbotSection />
      <div id="servicios">
        <ServicesSection />
      </div>
      <div id="planes">
        <PlansSection />
      </div>
      <PromoSection />
      <ClientSection />

      <OpinionSection />
      <FunctionsSection />
      {/*}
      <ComparativeSection />
      */}
      <RatesSection />
      <OurAlliesSection />
      <XSection />
      <TeamSection />
      <ContactUsSection />
      <Footer />

      <Routes>
        <Route path="/Blogs" element={<BlogSection />} />
        <Route path="/logistic" element={<LogisticPage />} />
      </Routes>
    </>
  );
};

export default App;
